<template>
  <div :class="dataType(data, 'type')">
    <div :class="getListItemClass()">
      <div class="channel-left"><img :src="getImage(data.image)" :alt="data.channelname"/></div>
      <div class="channel-center">
        <p class="channel-tit" v-html="data.title"></p>
        <p class="channel-time">{{ epgsStartTime(data.starttime) }} ~ {{ epgsEndTime(data.endtime) }}</p>
      </div>
      <div class="channel-right">
        <!-- 시청하기, 다시보기 -->
        <a v-if="dataType(data, 'if') === 'btn'" class="channel-btn" @click.prevent="goToPlayer(data)">
          {{ dataType(data, 'text') }}
        </a>

        <!-- 방송예약 -->
        <div v-else-if="dataType(data, 'if') !== 'noreplay sche-channel-end'" class="check-style02">
          <btn-live-alarm :isOn="data.alarm" :targetDate="targetDate()" :contentsId="data.channelid"
                          :programId="data.programid" :change-alarm-state="changeAlarmState" :data-index="index" class="live-view-ch"/>
        </div>
      </div>
    </div>

    <!-- 프로그레스바 -->
    <span v-if="dataType(data, '') === '시청하기'" class="progress-bar-wrap">
      <progress-bar :data="ratio(data.starttime, data.endtime)"/>
    </span>
  </div>
</template>

<script>
import ProgressBar from '@/views/schedule/ProgressBar'
import { VodInfoService } from '@/common/api/api.service'
import BtnLiveAlarm from '@/views/schedule/BtnLiveAlarm'
import { isApp } from '@/common/util/common'
import { resizeThumbnail } from '@/common/image.filter'
const getDateFromTimeString = (timeString) => {
  if (!timeString) {
    return Date()
  }
  let splitString = timeString.match(/^(\d+)-(\d+)-(\d+) (\d+):(\d+)$/)
  return new Date(splitString[1], splitString[2] - 1, splitString[3], splitString[4], splitString[5])
}
export default {
  components: {
    ProgressBar,
    BtnLiveAlarm
  },
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    },
    changeAlarmState: {
      type: Function
    }
  },
  data () {
    return {
      startTime: getDateFromTimeString(this.data.starttime) / (1000 * 60),
      endTime: getDateFromTimeString(this.data.endtime) / (1000 * 60),
      today: new Date() / (1000 * 60)
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    getListItemClass () {
      let defaultClass = 'sche-channel-list'
      if (this.data.alarm === 'y') {
        defaultClass += ' alarm-on'
      }
      return defaultClass
    },
    goToPlayer (epgData) {
      let sDate = epgData.starttime.replace(/(?:-|:| )/g, '')
      let eDate = epgData.endtime.replace(/(?:-|:| )/g, '')
      let curDate = this.getDate().replace(/(?:-|:| )/g, '')

      if (Number(curDate) > Number(eDate)) {
        // 다시보기
        VodInfoService.getContentIdByProgramId({ programID: epgData.programid }).then(({ data }) => {
          let postfix = data.contentid ? '&contentid=' + data.contentid : ''
          window.location.href = isApp() ? `captvpooq://program?programid=${epgData.programid}` : `/player/vod?programid=${epgData.programid}${postfix}`
        })
      } else if (Number(sDate) <= Number(curDate) && Number(eDate) > Number(curDate)) {
        // 시청하기
        window.location.href = `${isApp() ? 'captvpooq:/' : '/player'}/live?channelid=${epgData.channelid}`
      }
    },
    // 시작시간
    epgsStartTime (sTime) {
      return sTime.substring(sTime.length - 5, sTime.length)
    },
    // 종료시간
    epgsEndTime (eTime) {
      return eTime.substring(eTime.length - 5, eTime.length)
    },
    // 타입
    dataType (data, kind) {
      let sDate = data.starttime.replace(/(?:-|:| )/g, '')
      let eDate = data.endtime.replace(/(?:-|:| )/g, '')

      // 현재날짜
      let curDate = this.getDate().replace(/(?:-|:| )/g, '')

      // 다시보기
      if (Number(curDate) >= Number(eDate)) {
        if (!data.programid) return 'noreplay sche-channel-end'
        if (kind === 'type') {
          return 'sche-channel-end'
        } else if (kind === 'if') {
          return 'btn'
        }
        return '다시보기'
      // 시청하기
      } else if (Number(sDate) <= Number(curDate) && Number(eDate) > Number(curDate)) {
        if (kind === 'type') {
          return 'sche-channel-ing'
        } else if (kind === 'if') {
          return 'btn'
        }
        return '시청하기'
      }
      return 'sche-channel-reserve'
    },
    // 시청 예약 시간
    targetDate () {
      return this.data.starttime
    },
    // 지정된 자리수만큼 0을 채워주는 함수
    pad (num, width) {
      let numStr = num + ''
      return numStr.length >= width ? numStr
        : new Array((width - numStr.length) + 1).join('0') + numStr
    },
    getDate () {
      let date = new Date()
      return date.getFullYear() + '-' +
        this.pad(date.getMonth() + 1, 2) + '-' +
        this.pad(date.getDate(), 2) + ' ' +
        this.pad(date.getHours(), 2) + ':' +
        this.pad(date.getMinutes(), 2)
    },
    // 프로그래스바 수치
    ratio (sd, ed) {
      let sTime = new Date(sd.replace(/-/g, '/'))
      let eTime = new Date(ed.replace(/-/g, '/'))
      let cTime = new Date(this.getDate().replace(/-/g, '/'))
      let diff1 = (eTime.getTime() - sTime.getTime()) / (1000 * 60)
      let diff2 = (cTime.getTime() - sTime.getTime()) / (1000 * 60)
      let diff3 = (Number(diff1) - Number(diff2)) - Number(diff1)
      let ratio = Math.abs(diff3) / Number(diff1)
      return String(ratio.toFixed(2))
    }
  }
}
</script>
<style scoped>
  .sche-channel-list {
    border-bottom: 1px solid #2f2f2f;
    display: table;
    width: auto;
    table-layout: fixed;
    min-height: 60px;
    min-width: 100%;
    max-width: none;
  }
  /*.sche-channel-list.alarm-on {*/
  /*  background-color: #f3f3f3;*/
  /*}*/
  /*.sche-channel-end .channel-left, .sche-channel-end .channel-time, .sche-channel-end .channel-tit {*/
  /*  opacity: .6;*/
  /*}*/
  .sche-channel-end{
    position: relative;
  }
  .sche-channel-end:after{
    position: absolute;
    content: '';
    top: 0;
    display: block;
    width: 100%;
    height: 90px;
    opacity: 0.8;
    background-color: #1b1b1b;
    z-index: 1;
  }
  .channel-left,
  .channel-left img {
    overflow: hidden;
    border-radius: 8px;
  }
  .channel-left {
    display: table-cell;
    width: 88px;
    vertical-align: middle;
    text-align: center;
    padding: 0 13px;
  }
  .channel-left img {
    max-width: 100%;
  }
  img {
    outline: none;
  }
  .channel-center {
    display: table-cell;
    height: 89px;
    vertical-align: middle;
  }
  .channel-tit {
    font-size: 13px;
    line-height: 19px;
    color: #a5a5a5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    word-break: break-all;
    max-height: 38px;
  }
  .channel-time {
    margin-top: 3px;
    font-size: 12px;
    line-height: 13px;
    color: #a5a5a5;
  }
  .channel-right {
    position: relative;
    display: table-cell;
    width: 77px;
    vertical-align: middle;
    text-align: center;
    padding: 0 10px;
    z-index: 2;
  }
  .channel-btn {
    display: inline-block;
    width: 100%;
    line-height: 24px;
    border-radius: 55px;
    font-size: 11px;
    text-align: center;
  }
  .sche-channel-ing .channel-btn {
    border: 1px solid #1351f9;
    background-color: #1351f9;
    color: #fff;
  }
  .sche-channel-end .channel-btn {
    border: 1px solid #fff;
    background-color: transparent;
    color: #fff;
  }
  .sche-channel-ing .progress-bar-wrap {
    width: calc(100% - 98px);
    right: 10px;
  }
  .progress-bar-wrap {
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 3px;
    background-color: #2f2f2f;
    z-index: 100;
  }
  .sche-channel-ing,
  .sche-channel-reserve {
    position: relative;
  }
</style>
